import 'svelte/internal/disclose-version';

Home[$.FILENAME] = 'src/pages/Home.svelte';

import * as $ from 'svelte/internal/client';
import api from "../lib/api.js";
import Rail from "../components/Rail.svelte";
import RestaurantCard from "../components/RestaurantCard.svelte";
import Skeleton from "../components/Skeleton.svelte";
import { prefs } from "../lib/prefs.svelte.js";
import { session } from "../lib/session.svelte.js";
import { searchUrl } from "../lib/routes.js";

var root = $.add_locations($.from_html(`<p class="failed svelte-et6md">We couldn't reach the kitchen just now. Try refreshing in a moment.</p>`), Home[$.FILENAME], [[71, 2]]);
var root_1 = $.add_locations($.from_html(`<li><a class="svelte-et6md"> <span class="svelte-et6md"> </span></a></li>`), Home[$.FILENAME], [[106, 10, [[106, 14, [[106, 94]]]]]]);
var root_2 = $.add_locations($.from_html(`<section class="places svelte-et6md"><h2 class="svelte-et6md">Browse by town</h2> <ul class="svelte-et6md"></ul></section>`), Home[$.FILENAME], [[102, 4, [[103, 6], [104, 6]]]]);
var root_3 = $.add_locations($.from_html(`<!> <!> <!> <section class="grid-section svelte-et6md"><div class="head svelte-et6md"><h2 class="svelte-et6md">Neighbourhood favourites</h2> <a class="more svelte-et6md">See all</a></div> <div class="grid svelte-et6md"></div></section> <!> <!>`, 1), Home[$.FILENAME], [[87, 2, [[88, 4, [[89, 6], [90, 6]]], [92, 4]]]]);
var root_4 = $.add_locations($.from_html(`<div class="hero svelte-et6md"><p class="kicker svelte-et6md"> </p> <h1 class="svelte-et6md">Where's good around here?</h1></div> <!>`, 1), Home[$.FILENAME], [[63, 0, [[64, 2], [65, 2]]]]);

const $$css = {
	hash: 'svelte-et6md',
	code: '\n  .hero.svelte-et6md {\n    padding: 44px 0 36px;\n    max-width: 760px;\n  }\n  .kicker.svelte-et6md {\n    margin: 0 0 6px;\n    color: var(--accent);\n    font-weight: 600;\n    font-size: 0.9rem;\n    letter-spacing: 0.02em;\n  }\n  h1.svelte-et6md { font-size: clamp(2.1rem, 5vw, 3.1rem); line-height: 1.08; }\n\n  .grid-section.svelte-et6md { margin-bottom: 40px; }\n  .head.svelte-et6md { display: flex; align-items: baseline; justify-content: space-between; margin-bottom: 14px; }\n  h2.svelte-et6md { font-size: 1.32rem; }\n  .more.svelte-et6md { font-size: 0.86rem; font-weight: 600; color: var(--accent); }\n  .more.svelte-et6md:hover { text-decoration: underline; }\n\n  .grid.svelte-et6md {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(248px, 1fr));\n    gap: 20px;\n  }\n\n  .places.svelte-et6md { margin-bottom: 24px; }\n  .places.svelte-et6md ul:where(.svelte-et6md) { list-style: none; padding: 0; margin: 14px 0 0; display: flex; flex-wrap: wrap; gap: 10px; }\n  .places.svelte-et6md a:where(.svelte-et6md) {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: var(--sage-soft);\n    border-radius: var(--radius-pill);\n    padding: 9px 16px;\n    font-size: 0.9rem;\n  }\n  .places.svelte-et6md a:where(.svelte-et6md):hover { background: var(--accent-soft); }\n  .places.svelte-et6md span:where(.svelte-et6md) { color: var(--ink-faint); font-size: 0.78rem; }\n\n  .failed.svelte-et6md { color: var(--ink-soft); padding: 40px 0; }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function Home($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Home);
	$.append_styles($$anchor, $$css);

	let data = $.tag($.state(null), 'data');
	let loading = $.tag($.state(true), 'loading');
	let failed = $.tag($.state(false), 'failed');

	$.user_effect(() => {
		// Re-fetch when the visitor signs in so the personalised rails fill in.
		const _ = session.user?.id;

		let cancelled = false;

		$.set(loading, true);

		api.home().then((response) => {
			if (!cancelled) {
				$.set(data, response, true);
				$.set(failed, false);
			}
		}).catch(() => {
			if (!cancelled) $.set(failed, true);
		}).finally(() => {
			if (!cancelled) $.set(loading, false);
		});

		return () => {
			cancelled = true;
		};
	});

	// Anonymous visitors still get "recently viewed" — theirs lives in local storage.
	const localRecent = $.tag(
		$.derived(() => session.user
			? []
			: (prefs.recentlyViewed ?? []).map((item) => ({
				id: item.id,
				slug: item.slug,
				name: item.name,
				cuisine: item.cuisine ?? "",
				city: item.city ?? "",
				thumbnailUrl: item.thumbnailUrl,
				ratingAverage: 0,
				reviewCount: 0,
				priceLevel: 2,
				tags: []
			}))),
		'localRecent'
	);

	const greeting = $.tag(
		$.derived(() => {
			const hour = new Date().getHours();
			const who = session.user ? `, ${session.user.displayName.split(" ")[0]}` : "";

			if (hour < 11) return `Good morning${who}`;
			if (hour < 17) return `Good afternoon${who}`;

			return `Good evening${who}`;
		}),
		'greeting'
	);

	var $$exports = { ...$.legacy_api() };
	var fragment = root_4();
	var div = $.first_child(fragment);
	var p = $.child(div);
	var text = $.child(p, true);

	$.reset(p);
	$.next(2);
	$.reset(div);

	var node = $.sibling(div, 2);

	{
		var consequent = ($$anchor) => {
			$.add_svelte_meta(() => Skeleton($$anchor, { count: 8 }), 'component', Home, 69, 2, { componentTag: 'Skeleton' });
		};

		var consequent_1 = ($$anchor) => {
			var p_1 = root();

			$.append($$anchor, p_1);
		};

		var consequent_3 = ($$anchor) => {
			var fragment_2 = root_3();
			var node_1 = $.first_child(fragment_2);

			{
				let $0 = $.derived(() => session.user ? $.get(data).recentlyViewed : $.get(localRecent));

				$.add_svelte_meta(
					() => Rail(node_1, {
						title: 'Pick up where you left off',
						subtitle: 'Places you looked at recently',
						get items() {
							return $.get($0);
						}
					}),
					'component',
					Home,
					73,
					2,
					{ componentTag: 'Rail' }
				);
			}

			var node_2 = $.sibling(node_1, 2);

			{
				let $0 = $.derived(() => prefs.lastCuisine ?? 'good food');

				$.add_svelte_meta(
					() => Rail(node_2, {
						get title() {
							return `Because you like ${$.get($0) ?? ''}`;
						},
						subtitle: 'Suggestions based on what you\'ve been browsing',
						get items() {
							return $.get(data).forYou;
						}
					}),
					'component',
					Home,
					79,
					2,
					{ componentTag: 'Rail' }
				);
			}

			var node_3 = $.sibling(node_2, 2);

			$.add_svelte_meta(
				() => Rail(node_3, {
					title: 'Your saved list',
					subtitle: 'Everything you starred',
					get items() {
						return $.get(data).favorites;
					},
					moreHref: '/me'
				}),
				'component',
				Home,
				85,
				2,
				{ componentTag: 'Rail' }
			);

			var section = $.sibling(node_3, 2);
			var div_1 = $.child(section);
			var a = $.sibling($.child(div_1), 2);

			$.reset(div_1);

			var div_2 = $.sibling(div_1, 2);

			$.add_svelte_meta(
				() => $.each(div_2, 21, () => $.get(data).topRated, (restaurant) => restaurant.id, ($$anchor, restaurant) => {
					$.add_svelte_meta(
						() => RestaurantCard($$anchor, {
							get restaurant() {
								return $.get(restaurant);
							}
						}),
						'component',
						Home,
						94,
						8,
						{ componentTag: 'RestaurantCard' }
					);
				}),
				'each',
				Home,
				93,
				6
			);

			$.reset(div_2);
			$.reset(section);

			var node_4 = $.sibling(section, 2);

			{
				let $0 = $.derived(() => searchUrl("", { sort: "newest" }));

				$.add_svelte_meta(
					() => Rail(node_4, {
						title: 'Just added',
						subtitle: 'New to Upsorok',
						get items() {
							return $.get(data).newest;
						},

						get moreHref() {
							return $.get($0);
						}
					}),
					'component',
					Home,
					99,
					2,
					{ componentTag: 'Rail' }
				);
			}

			var node_5 = $.sibling(node_4, 2);

			{
				var consequent_2 = ($$anchor) => {
					var section_1 = root_2();
					var ul = $.sibling($.child(section_1), 2);

					$.add_svelte_meta(
						() => $.each(ul, 21, () => $.get(data).cities, (facet) => facet.value, ($$anchor, facet) => {
							var li = root_1();
							var a_1 = $.child(li);
							var text_1 = $.child(a_1, true);
							var span = $.sibling(text_1);
							var text_2 = $.child(span, true);

							$.reset(span);
							$.reset(a_1);
							$.reset(li);

							$.template_effect(
								($0) => {
									$.set_attribute(a_1, 'href', $0);
									$.set_text(text_1, $.get(facet).value);
									$.set_text(text_2, $.get(facet).count);
								},
								[
									() => searchUrl(`restaurants in ${$.get(facet).value.split(",")[0]}`)
								]
							);

							$.append($$anchor, li);
						}),
						'each',
						Home,
						105,
						8
					);

					$.reset(ul);
					$.reset(section_1);
					$.append($$anchor, section_1);
				};

				$.add_svelte_meta(
					() => $.if(node_5, ($$render) => {
						if ($.get(data).cities?.length) $$render(consequent_2);
					}),
					'if',
					Home,
					101,
					2
				);
			}

			$.template_effect(($0) => $.set_attribute(a, 'href', $0), [() => searchUrl("", { sort: "rating" })]);
			$.append($$anchor, fragment_2);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($.get(loading) && !$.get(data)) $$render(consequent); else if ($.get(failed)) $$render(consequent_1, 1); else if ($.get(data)) $$render(consequent_3, 2);
			}),
			'if',
			Home,
			68,
			0
		);
	}

	$.template_effect(() => $.set_text(text, $.get(greeting)));
	$.append($$anchor, fragment);

	return $.pop($$exports);
}